export default __webpack_public_path__ + "static/dearInventoryIcon-5564e7cb3aa8cd7c9760a8be8ee044d7.svg";